import { Box, Toast } from "@biom3/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { appConfig } from "@/constants";
import { usePassportProvider } from "@/context";
import { usePageEventOnce } from "@/hooks/usePageEventOnce";
import { trackLegacyEvent } from "@analytics";

// Duplicate of Layerswap.tsx for use in side drawer
// Will eventually replace it

export type LayerSwapSource = "BINANCE";

const screen = "Layerswap";

export const LayerSwap = ({
  userJourney,
  defaultFrom,
}: {
  userJourney: string;
  defaultFrom?: LayerSwapSource;
}) => {
  const { walletAddress } = usePassportProvider();
  const { t } = useTranslation();
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  const layerswapAnalytics = {
    userJourney,
    screen,
  };

  const layerswapURI = new URL("https://layerswap.io/app/");
  layerswapURI.searchParams.append("clientId", appConfig.LAYERSWAP_CLIENT_ID);
  defaultFrom && layerswapURI.searchParams.append("from", defaultFrom);
  layerswapURI.searchParams.append("to", "IMMUTABLEZK_MAINNET");
  layerswapURI.searchParams.append("lockAddress", "true");
  layerswapURI.searchParams.append("theme", "immutable");
  walletAddress &&
    layerswapURI.searchParams.append("destAddress", walletAddress);

  const onLoad = () => {
    trackLegacyEvent({
      ...layerswapAnalytics,
      control: "iFrame",
      controlType: "Effect",
      action: "Succeeded",
    });
    setLoading(false);
  };

  const onError = () => {
    trackLegacyEvent({
      ...layerswapAnalytics,
      control: "iFrame",
      controlType: "Effect",
      action: "Failed",
    });
    setLoading(false);
    setError(true);
  };

  usePageEventOnce({ screen, userJourney });

  return (
    <Box
      sx={{
        d: "grid",
        flexDirection: "column",
        background: "hsl(var(--card))",
        borderRadius: "base.borderRadius.x8",
        boxShadow: "base.shadow.400",
        height: "100%",
        width: "100%",
        overflow: "hidden",
      }}
    >
      <iframe
        title="LayerSwap"
        onLoad={() => onLoad()}
        onError={() => onError()}
        src={layerswapURI.href}
        style={{
          height: "100%",
          width: "100%",
          border: "none",
          opacity: loading ? 0 : 1,
          transition: "opacity 0.5s ease-out",
        }}
      />
      <Toast
        visible={!!error}
        variant="fatal"
        hideDismissButton={false}
        onCloseToast={() => setError(false)}
      >
        <Toast.Message size="xxSmall">{t("layerswap_failed")}</Toast.Message>
      </Toast>
    </Box>
  );
};
